import { render, staticRenderFns } from "./UserStakingLogs.vue?vue&type=template&id=4ac6294c&scoped=true&"
import script from "./UserStakingLogs.vue?vue&type=script&lang=js&"
export * from "./UserStakingLogs.vue?vue&type=script&lang=js&"
import style0 from "./UserStakingLogs.vue?vue&type=style&index=0&id=4ac6294c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6294c",
  null
  
)

export default component.exports